export default "<div id=\"sectionMenuScroll\"><ng-content></ng-content></div>\n"